export default __webpack_public_path__ + "static/media/logo.cbe8ba99.png";